import { setEmpresasAction } from './empresasActions';
import { useDispatch, useSelector } from 'react-redux';
import Empresa from '../../shared/entity/Empresa';
import { RootAppState } from '../store';

export const useEmpresas = (): [Empresa[], (emp: Empresa[]) => void] => {
  const empresas = useSelector<RootAppState>((state) => state.empresas) as Empresa[];
  const dispatch = useDispatch();
  const setEmpresas = (emp: Empresa[]) => {
    const action = setEmpresasAction(emp);
    dispatch(action);
  };
  return [empresas, setEmpresas];
};
